import React from 'react';
import { withTranslation } from 'react-i18next';

const AdvancedFieldError = ({ messages, t }) => messages && renderMessages(messages, t);

function renderMessages(messages, t) {
	let messagesList = [];
	messages = transformToArray(messages);
	messages.forEach((m, index) => {
		messagesList.push(
			<p key={index} style={{ color: 'red', fontSize: 'x-small', marginLeft: '0.3em' }}>
				<b>{t(m)}</b>
			</p>
		);
	});
	return messagesList;
}

function transformToArray(messages) {
	if (typeof messages === 'string') {
		messages = messages.split();
	} else {
		messages = transformIfObjectToArray(messages);
	}
	messages = messages.filter(m => m != 'EXCLUDED_ERROR_MESSAGE');
	return messages;
}

function transformIfObjectToArray(messages) {
	if (messages instanceof Object) {
		messages = Object.values(messages);
		messages = messages.filter(m => !!m).map(m => transformIfObjectToArray(m));
	}
	return messages;
}

AdvancedFieldError.defaultProps = {
	messages: null,
	t: m => m
};

export default withTranslation()(AdvancedFieldError);
